import React from 'react';
import { ShieldAlert, ExternalLink } from 'lucide-react';

export const DisclaimerBanner: React.FC = () => {
  return (
    <aside
      aria-label="Official Public Safety Advisory"
      className="bg-amber-50 border-y sm:border sm:rounded-lg border-amber-200/80 p-3 sm:p-4 text-amber-950 text-xs sm:text-sm my-4"
    >
      <div className="flex items-start gap-3">
        <ShieldAlert className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
        <div className="space-y-1">
          <p className="font-semibold text-amber-900">
            Public Safety Notice: SignalNear is an Independent Discovery Service
          </p>
          <p className="text-amber-800 leading-relaxed">
            SignalNear provides automated aggregation of publicly issued alerts from the US National Weather Service. 
            We are not a government agency, dispatch centre, or first-responder dispatch system. 
            The absence of an alert here does not guarantee that conditions in your exact area are safe. 
            For immediate life-safety emergencies, call <strong>911</strong> or monitor local broadcast emergency channels.
          </p>
          <div className="pt-1 flex flex-wrap gap-4 text-xs font-medium text-amber-900">
            <a
              href="https://www.weather.gov"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 hover:underline"
            >
              <span>weather.gov</span>
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href="https://www.ready.gov"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 hover:underline"
            >
              <span>ready.gov</span>
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

